<template>
  <div class="mapArrayPoint">
    <div class="reminderNameTitle">
      <i
        class="iconfont icon-guanbi2"
        style="color: red"
        @click.stop="closeReminder"
      ></i>
    </div>
    <div class="reminderDetail">
      <template v-for="(item, index) in pointarrayData" :key="index">
        <div class="reminderDetailItem" @click="arrayPointClick(item)">
          <img :src="item.icon" alt="" />
          <span :title="item.item.cameraName">{{ item.item.cameraName }}</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
import deviceIcon from "@/utils/deviceIcon";
export default defineComponent({
  name: "mapArrayPoint",
  components: {},
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return [
          {
            value: "icon-shanchu",
            name: "ceshi",
          },
        ];
      },
    },
  },
  setup(props, context) {
    const data = reactive({
      pointarrayData: [],
    });
    const refData = toRefs(data);
    watchEffect(() => {
      //需要转对象中点位名字放到cameraName上。统一绑定到html中
      data.pointarrayData =
        props.pointInfo &&
        props.pointInfo.map((item) => {
          if (item.values_.item.name) {
            item.values_.item.cameraName = item.values_.item.name;
          }
          if (item.values_.item.securityName) {
            item.values_.item.cameraName = item.values_.item.securityName;
          }
          if (item.values_.item.unitName) {
            item.values_.item.cameraName = item.values_.item.unitName;
          }
          item.values_.icon = deviceIcon[item.values_.poiType].iconImg;
          return item.values_;
        });
      console.log(data.pointarrayData);
    });

    const closeReminder = () => {
      context.emit("closeReminder");
    };
    const arrayPointClick = (item) => {
      context.emit("emitPointClick", item);
    };

    return {
      ...refData,
      closeReminder,
      arrayPointClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.mapArrayPoint {
  width: 160px;
  height: 170px;
  background: rgba(8, 13, 38, 0.8);
  color: #14d1b3;
  background-size: 100% 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 5px;
  overflow: auto;
  pointer-events: auto;
  .reminderNameTitle {
    width: 100%;
    @include flex-row-e-c;
    pointer-events: auto;
    i {
      cursor: pointer;
    }
  }

  .reminderDetail {
    width: 100%;
    height: 80%;
    overflow: auto;
    margin-bottom: 8px;

    .reminderDetailItem {
      margin: 6px 0;
      display: flex;
      cursor: pointer;
      img {
        width: 16px;
        margin-right: 16px;
      }
      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  & ::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: transparent;
    border-top-color: rgba(8, 13, 38, 0.8);
    top: 100%;
    left: 50%;
    margin-left: -10px;
  }
}
</style>
